<template>
  <div id="app">
    <Header v-show="$route.meta.showHeader"></Header>
    <!-- <router-view /> -->
    <!-- <keep-alive> -->
    <keep-alive>
      <router-view id="fileterContainer" v-if="$route.meta.keepAlive" :key="$route.fullPath + $route.query.t">
      </router-view>
    </keep-alive>
    <router-view id="fileterContainer" v-if="!$route.meta.keepAlive && isRouterAlive"
      :key="$route.fullPath + $route.query.t"></router-view>


  </div>
</template>

<script>
  import fetchql from "./common/fetch";
  export default {
    name: "App",
    components: {},
    provide() {
      return {
        pageReload: this.pageReload,
      };
    },
    filters: {
      subStr(num) {
        if (num) {
          return num.substring(0, 1);
        }
      },
    },
    data() {
      return {
        path: "",
        popupVisible: false,
        isShowPer: false,
        urlEcode: "",
        isRouterAlive: true,
      };
    },
    // 判断路由
    mounted() {
      if (this.$route.query.theme) {
        if (this.$route.query.theme == 1) {
          document
            .getElementsByTagName("body")[0]
            .setAttribute("style", "background:#ffffff !important;");
        } else if (this.$route.query.theme == 0) {
          document
            .getElementsByTagName("body")[0]
            .setAttribute("style", "background:#000000 !important;");
        }
      }



      let that = this;



    },
    created() {

    },
    watch: {

    },
    methods: {},
  };
  window.onload = function () {
    document.documentElement.addEventListener(
      "touchstart",
      function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      },
      false
    );
    var lastTouchEnd = 0;
    document.documentElement.addEventListener(
      "touchend",
      function (event) {
        var now = Date.now();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  };

</script>

<style lang="less">
  .mint-toast {
    z-index: 9999999 !important;
  }

  .mint-header.is-fixed {
    z-index: 99 !important;
  }

  .tcaptcha-transform {
    transform: scale(0.9);
    visibility: hidden;
  }

  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: none;
    touch-action: pan-y;
  }

  .v-modal {
    opacity: 0.8;
  }

  body {
    margin: 0;
    background: #000;
    -webkit-overflow-scrolling: touch;
  }

  #app {
    font-family: Helvetica, Arial, sans-serif;
    /* 'PingFang', */
  }

  input::-webkit-input-placeholder {
    color: #8d8f9f;
    /* font-size: 13px; */
  }

  input:-moz-placeholder {
    color: #8d8f9f;
    /* font-size: 13px; */
  }

  input::-moz-placeholder {
    color: #8d8f9f;
    /* font-size: 13px; */
  }

  input:-ms-input-placeholder {
    color: #8d8f9f;
    /* font-size: 13px; */
  }

  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 7px;
    //-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    //background: @primary;
    background: #4f5161;
  }

  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    //-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 7px;
    //background: #EDEDED;
    background: transparent;
  }

  .loadText {
    text-align: center;
    color: #8d8f9f !important;
    font-size: 14px;
    padding-bottom: 50px;
  }

  .loadimg {
    // width: ;
  }

  a {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-user-select: none;
    -moz-user-focus: none;
    -moz-user-select: none;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue